import { render, staticRenderFns } from "./CluPhysical.vue?vue&type=template&id=38698f24&"
import script from "./CluPhysical.vue?vue&type=script&lang=ts&"
export * from "./CluPhysical.vue?vue&type=script&lang=ts&"
import style0 from "./CluPhysical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports